/* eslint-disable prettier/prettier */
<template>
  <div class="fill-height">
    <!-- Modal for showing the chart -->
    <v-dialog v-if="rows.length > 0" v-model="showChartModal" max-width="1200" max-height="200">
      <v-card>
        <v-card-title class="px-8 pb-0 mb-0">{{ setTitle(modalTitle) }}
          <div class="flex-grow-1"></div> <v-btn icon
            @click="showChartModal = !showChartModal, updateURL(showChartModal, modalTitle)"><v-icon
              medium>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <chart-widget :changed="loadChart" :data="{ chart_type: modalTitle }" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tender_dialog" width="50%">
      <tender-profile :item="item" :selected_avatar="selected_avatar" @hideProfile="tender_dialog = false" />
    </v-dialog>
    <v-card tile flat>
      <v-card-title class="d-flex px-4 align-center justify-space-between flex-row">
        <div class="d-flex align-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2" small color="primary" outlined v-bind="attrs" v-on="on">
                <span>Analysis</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="(chart) in chartWidgets" :key="chart.key">
                <v-btn small block text class="justify-start" @click="openChartModal(chart.key)">
                  <v-icon small class="mr-2">{{ chart.icon }}</v-icon>
                  {{ chart.title }}
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex align-center">
          <!-- Regular button when no rows selected -->
          <v-btn v-if="selected.length === 0" color="primary" small outlined @click="downloadResults('all')"
            class="mr-2 toolbar-btn-responsive">
            <v-icon left class="toolbar-icon">mdi-download</v-icon>
            <span class="d-none d-md-inline toolbar-text">Download All</span>
          </v-btn>
          <!-- Menu button when rows are selected -->
          <v-menu v-else offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" small outlined v-bind="attrs" v-on="on" class="mr-2 toolbar-btn-responsive">
                <v-icon left class="toolbar-icon">mdi-download</v-icon>
                <span class="d-none d-md-inline toolbar-text">Download</span>
                <v-icon right class="d-none d-md-inline">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="downloadResults('all')">
                <v-list-item-title>Download All</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadResults('selected')">
                <v-list-item-title>Download Selected ({{ selected.length }})</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn :disabled="disableBookmarks" color="primary" small outlined @click="addMultipleItemsToList()"
            class="mr-2 toolbar-btn-responsive">
            <v-icon left class="toolbar-icon">mdi-checkbox-multiple-marked</v-icon>
            <span class="d-none d-md-inline toolbar-text">Add to Pipeline</span>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="disableBookmarks" color="primary" small outlined v-bind="attrs" v-on="on"
                class="mr-2 toolbar-btn-responsive">
                <v-icon left class="toolbar-icon">mdi-eye-off</v-icon>
                <span class="d-none d-md-inline toolbar-text">Exclude</span>
                <v-icon right class="d-none d-md-inline">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="excludeSelectedBuyers()">
                <v-list-item-icon>
                  <v-icon small>mdi-account-off</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Exclude Buyers ({{ selected.length }})</v-list-item-title>
              </v-list-item>
              <v-list-item @click="excludeSelectedSuppliers()">
                <v-list-item-icon>
                  <v-icon small>mdi-domain-off</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Exclude Suppliers ({{ selected.length }})</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn small tile icon
            href="https://docs.tendertrace.com/guide/user-documentation/searching-the-data/executing-a-quick-search#viewing-your-results"
            target="_blank">
            <v-icon color="secondary">mdi-help-circle-outline</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <div class="table-wrapper">
        <v-data-table v-model="selected" :headers="tableHeaders" :items="processedRows" :items-per-page="50"
          :hide-default-footer="true" :show-select="true" item-key="id" class="results-table" :mobile-breakpoint="0">
          <!-- Custom header for Type column with filter -->
          <template v-slot:header.disposition>
            <div class="text-center">
              <v-select class="subtitle-2 font-weight-bold pb-2" v-model="selected_type" :items="types" dense
                single-line hide-details style="width:150px;" label="Type" item-text="type" item-value="type"
                return-object @change="updateQuery()"></v-select>
            </div>
          </template>

          <!-- Custom header for Gov column with sorting -->
          <template v-slot:header.government="{ header }">
            <div class="text-left subtitle-2 font-weight-bold">
              {{ header.text }}
              <span>
                <v-icon :color="sort_color.government.asc" small @click="updateSort('government', 'asc')">
                  mdi-menu-up
                </v-icon>
              </span>
              <span>
                <v-icon :color="sort_color.government.desc" small @click="updateSort('government', 'desc')">
                  mdi-menu-down
                </v-icon>
              </span>
            </div>
          </template>

          <!-- Custom header for Buyer column with sorting -->
          <template v-slot:header.publisher="{ header }">
            <div class="text-left subtitle-2 font-weight-bold">
              {{ header.text }}
              <span>
                <v-icon :color="sort_color.publisher.asc" small @click="updateSort('publisher', 'asc')">
                  mdi-menu-up
                </v-icon>
              </span>
              <span>
                <v-icon :color="sort_color.publisher.desc" small @click="updateSort('publisher', 'desc')">
                  mdi-menu-down
                </v-icon>
              </span>
            </div>
          </template>

          <!-- Custom header for Supplier column with sorting -->
          <template v-slot:header.supplier="{ header }">
            <div class="text-left subtitle-2 font-weight-bold">
              {{ header.text }}
              <span>
                <v-icon :color="sort_color.supplier.asc" small @click="updateSort('supplier', 'asc')">
                  mdi-menu-up
                </v-icon>
              </span>
              <span>
                <v-icon :color="sort_color.supplier.desc" small @click="updateSort('supplier', 'desc')">
                  mdi-menu-down
                </v-icon>
              </span>
            </div>
          </template>

          <!-- Custom header for Expiry column with sorting -->
          <template v-slot:header.expiry_date="{ header }">
            <div class="text-left subtitle-2 font-weight-bold">
              {{ header.text }}
              <span>
                <v-icon :color="sort_color.expiry_date.asc" small @click="updateSort('expiry_date', 'asc')">
                  mdi-menu-up
                </v-icon>
              </span>
              <span>
                <v-icon :color="sort_color.expiry_date.desc" small @click="updateSort('expiry_date', 'desc')">
                  mdi-menu-down
                </v-icon>
              </span>
            </div>
          </template>

          <!-- Custom header for Start Date column with sorting -->
          <template v-slot:header.contract_start="{ header }">
            <div class="text-left subtitle-2 font-weight-bold">
              {{ header.text }}
              <span>
                <v-icon :color="sort_color.contract_start.asc" small @click="updateSort('contract_start', 'asc')">
                  mdi-menu-up
                </v-icon>
              </span>
              <span>
                <v-icon :color="sort_color.contract_start.desc" small @click="updateSort('contract_start', 'desc')">
                  mdi-menu-down
                </v-icon>
              </span>
            </div>
          </template>

          <!-- Custom header for Amount column with sorting -->
          <template v-slot:header.value="{ header }">
            <div class="text-left subtitle-2 font-weight-bold">
              {{ header.text }}
              <span>
                <v-icon :color="sort_color.value.asc" small @click="updateSort('value', 'asc')">
                  mdi-menu-up
                </v-icon>
              </span>
              <span>
                <v-icon :color="sort_color.value.desc" small @click="updateSort('value', 'desc')">
                  mdi-menu-down
                </v-icon>
              </span>
            </div>
          </template>

          <!-- Custom header for Transparency column with info icon -->
          <template v-slot:header.transparency_score="{ header }">
            <div class="text-left subtitle-2 font-weight-bold d-flex align-center">
              {{ header.text }}
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn class="pt-0 ml-1" x-small v-on="on" icon @click="openTransparencyDialogFromHeader()">
                    <v-icon small color="primary">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>What is the Transparency Score?</span>
              </v-tooltip>
            </div>
          </template>


          <!-- Government column -->
          <template v-slot:item.government="{ item }">
            <div class="d-flex align-center">
              <v-avatar :color="item._govColor" size="32" class="mr-0">
                <span class="white--text caption">{{ item.government }}</span>
              </v-avatar>
            </div>
          </template>

          <!-- Notice column -->
          <template v-slot:item.title="{ item }">
            <div class="py-1 pl-0 pr-1">
              <div class="body-2 font-weight-medium title-wrap-2-lines title-main" style="max-width:300px;">
                <router-link target="_blank" text :to="{ name: 'tender', params: { id: item.id } }">{{ item.title
                  }}</router-link>
              </div>
              <div class="caption text-truncate title-meta" style="max-width:300px;">
                <span>
                  <a target="_blank" text @click="
                    showHideDetails(item, item._govColor)
                    ">{{ item.recid }}</a>
                </span>
                <span class="pl-1">
                  <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small color="secondary" @click="
                        showHideDetails(item, item._govColor)
                        "><v-icon small>mdi-eye-outline</v-icon></v-btn>
                    </template>
                    <span>Preview the notice</span>
                  </v-tooltip>
                </span>
                <span class="pl-1">
                  <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small color="#4EB888" light :href="item.url" target="_blank"
                        :disabled="disableIcon(item.url)" style="text-decoration: none !important;">
                        <v-icon small>mdi-web</v-icon>
                      </v-btn>
                    </template>
                    <span>Open Source Page</span>
                  </v-tooltip>
                </span>
              </div>

              <div class="caption text-truncate title-category" style="max-width:200px;">
                <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                  <template v-slot:activator="{ on }">
                    <router-link text style="text-decoration: none;" v-on="on" :to="{
                      name: 'category',
                      params: {
                        id: item.category_id
                      }
                    }">{{ item.category }}</router-link>
                  </template>
                  <span>{{ item.category }}</span>
                </v-tooltip>
              </div>
              <div class="title-tags">
                <span v-if="item.is_consultancy_services == 'Yes'">
                  <router-link target="_blank" :to="{ name: 'search', query: { isconsultancy: true } }">
                    <v-chip label color="secondary" x-small class="mr-1 mb-1">
                      {{ 'Consultancy' }}
                    </v-chip>
                  </router-link>
                </span>
                <span v-if="item.indigenous == true">
                  <router-link target="_blank" :to="{ name: 'search', query: { isindigenous: true } }">
                    <v-chip label color="secondary" x-small class="mr-1 mb-1">
                      {{ 'Indigenous' }}
                    </v-chip>
                  </router-link>
                </span>

                <span v-for="(tag, index) in item._matchedFields" :key="index">
                  <router-link target="_blank" :to="{ name: 'search', query: { tender: [tag] } }">
                    <v-chip label color="primary" x-small class="mr-1 mb-1">
                      {{ tag }}
                    </v-chip>
                  </router-link>
                </span>
              </div>
            </div>
          </template>

          <!-- Type column -->
          <template v-slot:item.disposition="{ item }">
            <div class="py-0 px-0">
              <div class="text-left caption" style="font-size: 14px;">
                <router-link v-if="item.son_ref"
                  :to="{ path: '/panel', query: { son_id: item.son_ref, government: item.government } }">
                  <v-chip x-small outlined :color="item._dispositionColor" label text-color="secondary">
                    <v-icon x-small left>mdi-label</v-icon>
                    {{ item._dispositionText }}
                  </v-chip>
                </router-link>

                <v-chip v-else x-small outlined :color="item._dispositionColor" label text-color="secondary">
                  <v-icon x-small left>mdi-label</v-icon>
                  {{ item._dispositionText }}
                </v-chip>
              </div>
            </div>
          </template>

          <!-- Buyer column -->
          <template v-slot:item.publisher="{ item }">
            <div class="py-1 pr-1 pl-1">
              <div class="caption text-uppercase" style="max-width:200px; word-wrap: break-word; font-size: 14px;">
                <router-link text style="text-decoration: none;"
                  :to="{ name: 'entity', params: { id: item.publisher_id } }">
                  {{ item.publisher }}</router-link>
              </div>
              <div>
                <span v-for="pc in item.publisher_clusters" :key="pc.cluster_id">
                  <router-link target="_blank" :to="{ name: 'cluster', params: { clusterId: pc.cluster_id } }">
                    <v-chip label color="primary" x-small class="mr-1 mb-1" outlined>
                      <v-icon x-small left>
                        mdi-hexagon-multiple
                      </v-icon>
                      {{ pc.cluster_name }}
                    </v-chip>
                  </router-link>
                </span>
              </div>
            </div>
          </template>

          <!-- Supplier column -->
          <template v-slot:item.supplier="{ item }">
            <div class="py-1 pr-1 pl-1">
              <div class="caption text-uppercase" style="max-width:200px; word-wrap: break-word; font-size: 14px;">
                <router-link text style="text-decoration: none;"
                  :to="{ name: 'supplier', params: { id: item.supplier_id } }">
                  {{ item.supplier }}</router-link>
              </div>
              <div>
                <span v-for="sc in item.supplier_clusters" :key="sc.cluster_id">
                  <router-link target="_blank" :to="{ name: 'cluster', params: { clusterId: sc.cluster_id } }">
                    <v-chip label color="primary" x-small class="mr-1 mb-1" outlined>
                      <v-icon x-small left>
                        mdi-hexagon-multiple
                      </v-icon>
                      {{ sc.cluster_name }}
                    </v-chip>
                  </router-link>
                </span>
              </div>
            </div>
          </template>

          <!-- Expiry column -->
          <template v-slot:item.expiry_date="{ item }">
            <div class="py-1 px-1">
              <div class="caption" style="font-size: 14px;">
                {{ item._formattedDate }}
              </div>
            </div>
          </template>

          <!-- Start Date column -->
          <template v-slot:item.contract_start="{ item }">
            <div class="py-1 px-1">
              <div class="caption" style="font-size: 14px;">
                {{ item._formattedStartDate }}
              </div>
            </div>
          </template>

          <!-- Amount column -->
          <template v-slot:item.value="{ item }">
            <div class="py-1 px-1">
              <div class="caption" style="font-size: 14px;">
                {{ item._formattedCurrency }}
              </div>
            </div>
          </template>

          <!-- Transparency Score column -->
          <template v-slot:item.transparency_score="{ item }">
            <div class="py-1 px-1">
              <span
                :style="{ color: getTransparencyColor(item.transparency_score || 0), fontWeight: 'bold', cursor: 'pointer' }"
                @click="openTransparencyDialog(item)" class="caption">
                {{ Math.ceil(item.transparency_score || 0) }}%
              </span>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="showListManager" max-width="1000px" scrollable>
      <list-manager v-show="showListManager" :tenders="tendersToAdd" :initialSelectedLists="list_selections"
        :change="bookmark_changed" @hide-list-manager="showListManager = false" @pipeline-updated="updateBookmarks">

      </list-manager>
    </v-dialog>
    <v-divider></v-divider>
    <div v-if="hit_info.total_pages >= 1 && !hide_pagination" class="text-center pt-3">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3">
          <v-pagination v-model="current_page" :length="num_pages" :total-visible="5" prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right" @input="getPage(current_page)"></v-pagination>
          <p class="caption font-italic" v-if="num_pages == 100">
            Only the first 5000 records will be retrieved. Consider narrowing
            your search.
          </p>
        </v-col>
      </v-row>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Download Pages Dialog -->
    <download-pages-dialog v-model="showDownloadDialog" :hit-info="hit_info" :json-query="json_query"
      :hide-pagination="hide_pagination" :current-page-rows="processedRows.length"
      @downloading="overlay = $event"></download-pages-dialog>

    <!-- Transparency Score Explanation Dialog -->
    <transparency-breakdown-dialog v-model="showTransparencyBreakdown"
      :transparency-checks="selectedTransparencyChecks" />
  </div>
</template>

<script>
import { bus } from "../main.js";
import moment from "moment";
import { getUserLists, addToList, getPipelines } from "./APIManager.js";
import { download, getMatchedFields, getKey, getCurrencySymbol, parseJSON } from "./Utils.js";
import TenderProfile from "./TenderProfile.vue";
import ListManager from "./ListManager.vue";
import ChartWidget from "./ChartWidget.vue";
import DownloadPagesDialog from "./DownloadPagesDialog.vue";
import TransparencyBreakdownDialog from "./TransparencyBreakdownDialog.vue";
import { govColor } from "./Utils.js";

export default {
  components: {
    TenderProfile,
    ListManager,
    ChartWidget,
    DownloadPagesDialog,
    TransparencyBreakdownDialog
  },

  props: {
    //results_drawer: Boolean
    hide_pagination: Boolean,
    tenders: [],
    hit_info: {},
    json_query: {},
    page_num: Number,
    type_filter: Boolean
  },
  data() {
    return {
      loadChart: Number,
      showChartModal: false,
      modalTitle: '',
      selectedItem: false,
      showPreview: false,
      showListManager: false,
      tendersToAdd: [],
      chartWidgets: [
        {
          title: "Expiring Soon",
          key: 'expiring-soon',
          icon: 'mdi-clock'
        },
        {
          title: "Contract Distribution",
          key: 'contract-distribution',
          icon: 'mdi-chart-bubble'
        },
        {
          title: "Government Spending",
          key: 'government-spending-breakdown',
          icon: 'mdi-chart-tree'
        },
        {
          title: "Market Share",
          key: 'market-share',
          icon: 'mdi-chart-donut'
        },
        {
          title: "Spend Comparison",
          key: 'spending-comparison',
          icon: 'mdi-compare'
        },
        {
          title: "Quarterly Trends",
          key: 'quarterly-trends',
          icon: 'mdi-finance'
        },
        {
          title: "Rolling 12M",
          key: 'market-activity',
          icon: 'mdi-signal'
        }
      ],
      types: [
        { type: "All Types" },
        { type: "Awards" },
        { type: "Requests / ATMs" },
        { type: "Grant Awards" },
        { type: "Grant Opportunities" }
      ],
      selected_type: { type: "All Types" },
      //rows: [],
      //states: {"NSW": "#ff4081", "QLD": "#ff4081", "WA":"#ff4081", "AUS": "#ff4081", "VIC": "#ff4081", "TAS":"#ff4081", "NT":"#ff4081", "ACT":"#ff4081"},
      selected_sort: { label: "Overview", value: "snapshot" },
      sort_options: [
        { label: "Amount", value: "value" },
        { label: "Expiry", value: "contract_end" },
        { label: "Supplier", value: "supplier" }
      ],
      item_details: { show: false, record: {} },
      saved: [{ tender_id: "", value: false }],
      supplier_query: {},
      publisher_query: {},
      current_sort_col: "value",
      current_sort_order: "desc",
      //num_pages: 6,
      current_page: this.page_num,
      selectList: false,
      user_lists: [],
      added_tender: "",
      selectedTender: null,
      list_search: null,
      message: null,
      overlay: false,
      sort_btn_colour: "#FFFFFF",
      tender_dialog: false,
      selected_avatar: "",
      rows: [],
      item: null,
      sort_color: {
        value: { asc: null, desc: null },
        expiry_date: { asc: null, desc: null },
        contract_start: { asc: null, desc: null },
        supplier: { asc: null, desc: null },
        publisher: { asc: null, desc: null },
        government: { asc: null, desc: null }
      },
      bookmark_changed: 0,
      list_selections: [],
      selected: [],
      // Memoization caches for expensive operations
      matchedFieldsCache: new Map(),
      govColorCache: new Map(),
      currencyCache: new Map(),
      dateCache: new Map(),
      dispositionColorCache: new Map(),
      dispositionTextCache: new Map(),
      // State for computed values
      processedRows: [],
      tableHeaders: [],
      // Download dialog state
      showDownloadDialog: false,
      // Transparency dialog state
      showTransparencyBreakdown: false,
      selectedTransparencyChecks: null

    };
  },

  computed: {
    disableBookmarks() {
      return this.selected.length == 0 ? true : false;
    },

    num_pages: function () {
      let max_hits = this.hit_info.total_pages;

      if (max_hits > 100) {
        max_hits = 100;
      } else {
        max_hits = this.hit_info.total_pages;
      }
      return max_hits;
    }
  },

  watch: {
    // Watch tenders prop and update rows reactively
    tenders: {
      handler(newTenders) {
        if (newTenders && Array.isArray(newTenders)) {
          this.rows = newTenders;
          this.buildTable();
        }
      },
      immediate: true
    },

    $route(to, from) {
      // Detect changes in query parameters
      if (to.query["showChartModal"] && to.query["widgetName"]) {
        this.openChartModal(to.query["widgetName"]);
      } else {
        this.showChartModal = false; // Ensure the modal closes if the query is removed
      }
    }
  },

  mounted: function () {

    const showChartModal = this.$route.query["showChartModal"];
    const widgetName = this.$route.query["widgetName"];
    if (showChartModal && widgetName) {
      this.openChartModal(widgetName);
    }

    this.rows = this.tenders;

    this.buildTable();

    this.getLists();

    this.setTypeFilter();

    if (this.json_query["sort_field"]) {
      const sortField = this.json_query["sort_field"];
      const sortOrder = this.json_query["sort_order"];
      if (this.sort_color[sortField] && this.sort_color[sortField][sortOrder] !== undefined) {
        this.sort_color[sortField][sortOrder] = 'primary';
      }
      //this.sort_color[sort_field][sort_order] = 'primary';
    }
    else {
      this.sort_color["expiry_date"]["desc"] = 'primary';
    }

    // bus.$on("update-propsect-lists", data => {
    //   //////console.log("update-propsect-lists");
    //   this.getLists();
    // });

  },

  methods: {

    getMatchedFields,
    getKey,
    parseJSON,

    buildTable() {
      // Process rows with all formatting computed first
      if (!this.rows || this.rows.length === 0) {
        this.processedRows = [];
        this.tableHeaders = [];
        return;
      }

      this.processedRows = this.rows.map(item => {
        // Create a new object to avoid mutating the original
        const processed = { ...item };

        // Pre-compute matched fields
        if (item.matched_fields) {
          const cacheKey = JSON.stringify(item.matched_fields);
          if (!this.matchedFieldsCache.has(cacheKey)) {
            this.matchedFieldsCache.set(cacheKey, getMatchedFields(item.matched_fields));
          }
          processed._matchedFields = this.matchedFieldsCache.get(cacheKey);
        } else {
          processed._matchedFields = [];
        }

        // Pre-compute government color
        if (item.government) {
          if (!this.govColorCache.has(item.government)) {
            this.govColorCache.set(item.government, govColor(item.government));
          }
          processed._govColor = this.govColorCache.get(item.government);
        }

        // Pre-compute currency formatting
        if (item.value !== undefined && item.value !== null) {
          const cacheKey = String(item.value);
          if (!this.currencyCache.has(cacheKey)) {
            if (!isNaN(item.value)) {
              this.currencyCache.set(cacheKey,
                getCurrencySymbol() +
                Math.round(item.value)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              );
            } else {
              this.currencyCache.set(cacheKey, null);
            }
          }
          processed._formattedCurrency = this.currencyCache.get(cacheKey);
        }

        // Pre-compute date formatting
        if (item.expiry_date) {
          if (!this.dateCache.has(item.expiry_date)) {
            this.dateCache.set(item.expiry_date, moment(item.expiry_date).format("DD MMM YYYY"));
          }
          processed._formattedDate = this.dateCache.get(item.expiry_date);
        } else {
          processed._formattedDate = null;
        }

        // Pre-compute start date formatting
        const startDate = item.contract_start
          || (['Request', 'Grant Opportunity'].includes(item.disposition) ? item.published_date : null);
        if (startDate) {
          const startDateKey = `start_${startDate}`;
          if (!this.dateCache.has(startDateKey)) {
            this.dateCache.set(startDateKey, moment(startDate).format("DD MMM YYYY"));
          }
          processed._formattedStartDate = this.dateCache.get(startDateKey);
        } else {
          processed._formattedStartDate = null;
        }

        // Pre-compute disposition color
        if (item.disposition) {
          if (!this.dispositionColorCache.has(item.disposition)) {
            let color = "grey";
            switch (item.disposition) {
              case "Request":
              case "Grant Opportunity":
                color = "#4EB888";
                break;
              case "Contract Notice":
              case "Grant":
                color = "#FF1463";
                break;
            }
            this.dispositionColorCache.set(item.disposition, color);
          }
          processed._dispositionColor = this.dispositionColorCache.get(item.disposition);
        }

        // Pre-compute disposition text
        if (item.disposition) {
          const cacheKey = `${item.disposition}_${item.son_ref || ''}`;
          if (!this.dispositionTextCache.has(cacheKey)) {
            let disposition = item.disposition;
            if (disposition == "Contract Notice") {
              disposition = "Contract";
            }
            if (item.son_ref) {
              disposition = "Panel Contract";
            }
            this.dispositionTextCache.set(cacheKey, disposition);
          }
          processed._dispositionText = this.dispositionTextCache.get(cacheKey);
        }

        // Pre-compute pipelines for this notice
        const tenderId = parseInt(item.id);
        processed._pipelines = [];
        if (this.user_lists && Array.isArray(this.user_lists)) {
          for (const pipeline of this.user_lists) {
            if (pipeline.search_query && pipeline.search_query.tender_id) {
              const tenderIds = Array.isArray(pipeline.search_query.tender_id)
                ? pipeline.search_query.tender_id.map(id => parseInt(id))
                : [parseInt(pipeline.search_query.tender_id)];
              if (tenderIds.includes(tenderId)) {
                processed._pipelines.push({
                  id: pipeline.id,
                  name: pipeline.name || 'Unnamed Pipeline',
                  search_query: pipeline.search_query
                });
              }
            }
          }
        }

        return processed;
      });

      // Initialize table headers
      this.tableHeaders = [
        {
          text: 'Gov',
          value: 'government',
          sortable: false,
          width: '32px'
        },
        {
          text: 'Notice',
          value: 'title',
          sortable: false,
          width: '300px'
        },
        {
          text: 'Type',
          value: 'disposition',
          sortable: false,
          width: '120px'
        },
        {
          text: 'Buyer',
          value: 'publisher',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Supplier',
          value: 'supplier',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Start ',
          value: 'contract_start',
          sortable: false,
          width: '100px'
        },
        {
          text: 'Expiry',
          value: 'expiry_date',
          sortable: false,
          width: '100px'
        },
        {
          text: 'Amount',
          value: 'value',
          sortable: false,
          width: '100px'
        },
        {
          text: 'Transparency',
          value: 'transparency_score',
          sortable: false,
          width: '80px'
        }
      ];
    },

    setTitle(str) {
      return str
        .split('-')                // Split the string by hyphens
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' ');                 // Join the words without spaces
    },

    updateURL(show, widgetName) {
      //quietly update the URL without triggering a route changed event
      const url = new URL(window.location);
      if (show) {
        url.searchParams.set("showChartModal", show);
        url.searchParams.set("widgetName", widgetName);
        window.history.pushState({}, '', url);
        this.loadChart = (Math.random() + Date.now()) * Math.random();
      } else {
        url.searchParams.delete("showChartModal");
        url.searchParams.delete("widgetName");
        window.history.pushState({}, '', url);
      }
    },

    openChartModal(widgetName) {
      ////console.log("OPEN MODAL");
      this.modalTitle = widgetName; // Customize the title or load relevant data
      this.showChartModal = true;
      this.updateURL(true, widgetName);
      /* let routeData = this.$router.resolve({name: widgetName, query: this.$route.query});
      window.open(routeData.href, '_blank'); */
    },



    addItemToList(targetItem) {
      ////////console.log("targetItem: ", targetItem);

      this.list_selections = [];

      for (var i in this.user_lists) {
        let list = this.user_lists[i].search_query.tender_id;

        // Check if pipeline contains ALL selected tenders (in this case, just the one)
        if (list.includes(parseInt(targetItem.id))) {
          this.list_selections.push(this.user_lists[i].id);
        }
      }

      this.tendersToAdd = [targetItem];
      this.showListManager = true;

    },

    addMultipleItemsToList() {
      // Pass full tender objects instead of just IDs
      const selectedTenders = this.selected;

      this.list_selections = [];

      // Extract IDs for checking which lists contain the tenders
      const selectedIds = selectedTenders.map(item => item.id);

      // Check which lists already contain ALL of the selected items
      for (var i in this.user_lists) {
        let list = this.user_lists[i].search_query.tender_id;

        // Check if this pipeline contains ALL selected tenders
        const containsAll = selectedIds.every(tenderId =>
          list.includes(parseInt(tenderId))
        );

        if (containsAll) {
          this.list_selections.push(this.user_lists[i].id);
        }
      }

      this.tendersToAdd = selectedTenders;
      this.showListManager = true;
    },

    setBookmarks(data) {
      this.user_lists = data;

      // Parse search queries
      for (var i in this.user_lists) {
        this.user_lists[i].search_query = JSON.parse(this.user_lists[i].search_query);
      }

      // Create a Set of all bookmarked tender IDs for O(1) lookup
      const bookmarkedIds = new Set();
      for (var l in this.user_lists) {
        const tenderIds = this.user_lists[l].search_query.tender_id;
        if (Array.isArray(tenderIds)) {
          tenderIds.forEach(id => {
            bookmarkedIds.add(parseInt(id));
          });
        }
      }

      // Single pass through rows to set bookmarked status
      for (var i in this.rows) {
        const tenderId = parseInt(this.rows[i].id);
        this.rows[i]["bookmarked"] = bookmarkedIds.has(tenderId);
      }

      // Rebuild table to update processedRows with bookmarked status
      this.buildTable();
    },

    async updateBookmarks(bookmark_data) {
      //console.log("Received pipeline-updated event:", bookmark_data);

      const updatedPipelines = await getPipelines();
      this.setBookmarks(updatedPipelines.data);

      bus.$emit("refresh_lists", true);

    },

    setTypeFilter() {

      var qry = JSON.parse(JSON.stringify(this.$route.query));

      if (qry["disposition"] == "Contract Notice") {
        this.selected_type = { type: "Awards" };
      } else if (qry["disposition"] == "Request") {
        this.selected_type = { type: "Requests / ATMs" };
      } else if (qry["disposition"] == "Grant") {
        this.selected_type = { type: "Grant Awards" };
      } else if (qry["disposition"] == "Grant Opportunity") {
        this.selected_type = { type: "Grant Opportunities" };
      } else {
        this.selected_type = { type: "All Types" };
      }

    },

    excludeSupplier(supplier) {

      var qry = JSON.parse(JSON.stringify(this.$route.query));

      if (qry["exclude_supplier"]) {
        qry["exclude_supplier"].push(supplier);
      } else {
        qry["exclude_supplier"] = [supplier];
      }

      this.$router.push({ name: "search", query: qry });
    },

    excludePublisher(publisher) {

      var qry = JSON.parse(JSON.stringify(this.$route.query));

      if (qry["exclude_publisher"]) {
        qry["exclude_publisher"].push(publisher);
      } else {
        qry["exclude_publisher"] = [publisher];
      }

      this.$router.push({ name: "search", query: qry });
    },

    excludeSelectedBuyers() {
      if (this.selected.length === 0) {
        return;
      }

      // Get all unique buyers from selected rows
      const uniqueBuyers = [...new Set(
        this.selected
          .map(item => item.publisher)
          .filter(publisher => publisher && publisher.trim() !== '')
      )];

      if (uniqueBuyers.length === 0) {
        return;
      }

      var qry = JSON.parse(JSON.stringify(this.$route.query));

      // Add unique buyers to exclude list
      if (qry["exclude_publisher"]) {
        // Merge with existing excludes, avoiding duplicates
        const existingExcludes = Array.isArray(qry["exclude_publisher"])
          ? qry["exclude_publisher"]
          : [qry["exclude_publisher"]];
        const combined = [...new Set([...existingExcludes, ...uniqueBuyers])];
        qry["exclude_publisher"] = combined;
      } else {
        qry["exclude_publisher"] = uniqueBuyers;
      }

      this.$router.push({ name: "search", query: qry });
    },

    excludeSelectedSuppliers() {
      if (this.selected.length === 0) {
        return;
      }

      // Get all unique suppliers from selected rows
      const uniqueSuppliers = [...new Set(
        this.selected
          .map(item => item.supplier)
          .filter(supplier => supplier && supplier.trim() !== '')
      )];

      if (uniqueSuppliers.length === 0) {
        return;
      }

      var qry = JSON.parse(JSON.stringify(this.$route.query));

      // Add unique suppliers to exclude list
      if (qry["exclude_supplier"]) {
        // Merge with existing excludes, avoiding duplicates
        const existingExcludes = Array.isArray(qry["exclude_supplier"])
          ? qry["exclude_supplier"]
          : [qry["exclude_supplier"]];
        const combined = [...new Set([...existingExcludes, ...uniqueSuppliers])];
        qry["exclude_supplier"] = combined;
      } else {
        qry["exclude_supplier"] = uniqueSuppliers;
      }

      this.$router.push({ name: "search", query: qry });
    },

    updateQuery() {

      var qry = JSON.parse(JSON.stringify(this.$route.query));

      if (this.selected_type.type == "Awards") {
        qry["disposition"] = "Contract Notice";
      } else if (this.selected_type.type == "Requests / ATMs") {
        qry["disposition"] = "Request";
      } else if (this.selected_type.type == "Grant Awards") {
        qry["disposition"] = "Grant";
      } else if (this.selected_type.type == "Grant Opportunities") {
        qry["disposition"] = "Grant Opportunity";
      } else if (this.selected_type.type == "All Types") {
        // Remove disposition filter to show all types
        delete qry["disposition"];
      } else {
        // Fallback: include all types
        qry["disposition"] = ["Contract Notice", "Request", "Grant", "Grant Opportunity"];
      }

      this.$router.push({ name: "search", query: qry });
    },

    updateSort(sort_field, sort_order) {

      let sortQuery = {};

      sortQuery["sort_field"] = { field: "sort_field", value: sort_field };
      sortQuery["sort_order"] = { field: "sort_order", value: sort_order };

      this.$emit("updateSort", sortQuery);

    },

    downloadResults(type = 'all') {
      if (type === 'selected' && this.selected.length > 0) {
        // Download only selected rows
        download(this.selected, 'selected');
      } else if (type === 'all') {
        // Show dialog to select pages for download
        this.showDownloadDialog = true;
      } else {
        // Fallback: download current page
        download(this.rows, this.current_page);
      }
    },

    borderHighlight(gov) {
      const color = govColor(gov);

      var style = {
        "border-left-width": 5 + "px",
        "border-left-style": "solid",
        "border-left-color": color + " !important"
      };

      return style;
    },

    dispositionColor(dis) {
      var color = "grey";
      switch (dis) {
        case "Request":
          color = "#4EB888";
          break;
        case "Grant Opportunity":
          color = "#4EB888";
          break;
        case "Contract Notice":
          color = "#FF1463";
          break;
        case "Grant":
          color = "#FF1463";
          break;
      }

      return color;
    },

    dispositionText(item) {
      let disposition = item.disposition;
      if (disposition == "Contract Notice") {
        disposition = "Contract";
      }

      if (disposition == "Grant") {
        disposition = "Grant";
      }

      if (item.son_ref) {
        disposition = "Panel Contract";
      }
      return disposition;
    },

    govAvatarColor(gov) {
      return govColor(gov);
    },

    getPage(number) {
      this.$emit("change-page", this.current_page);
      ////////////////console.log("CLICKED PAGE: " + this.current_page);
    },
    formattedCurrency: function (amount) {
      ////////////////console.log("AMOUNT: " + amount);
      if (!isNaN(amount)) {
        return (
          getCurrencySymbol() +
          Math.round(amount)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        );
      }
    },

    getStatusColour(item) {
      if (item.status === "published") {
        return { color: "#0b875b", text: "white" };
      } else {
        return { color: "#E0E0E0", text: "#1b1b1b" };
      }
    },

    showHideDetails(item, avatar) {
      //this.item_details = !this.item_details;
      this.tender_dialog = true;
      this.item = item;
      this.selected_avatar = avatar;
      //bus.$emit("show-hide-details", this.item, this.this.selected_avatar);
    },

    disableIcon(url) {
      if (!url) {
        return true;
      } else {
        return false;
      }
    },

    getLists() {
      getUserLists()
        .then(data => {
          this.setBookmarks(data);
        })
        .catch(error => {
          error;
        });
    },

    search_supplier(supplier_abn, supplier_name) {
      if (
        !supplier_abn ||
        supplier_abn == "Not Specified" ||
        supplier_abn == "Unknown" ||
        supplier_abn == "NULL"
      ) {
        var name = new Array(supplier_name);
        this.supplier_query["supplier"] = name;
      } else {
        var abn = new Array(supplier_abn);
        this.supplier_query["supplier_company_number"] = abn;
      }
      bus.$emit("submit-search", this.supplier_query);
      this.supplier_query = {};
    },

    search_publisher(publisher_name) {
      var name = new Array(publisher_name);
      this.publisher_query["publisher"] = name;

      bus.$emit("submit-search", this.publisher_query);
      this.publisher_query = {};
    },

    getTransparencyColor(score) {
      // Use the same color logic as Tender.vue
      switch (true) {
        case (score >= 90):
          return "#4eb888";
        case (score >= 70):
          return "#DAD870";
        case (score >= 50):
          return "#FF9636";
        case (score < 50):
          return "#FF5C4D";
        default:
          return "#FF5C4D";
      }
    },

    extrapolateTransparencyChecks(transparencyChecks) {
      if (!transparencyChecks) {
        return null;
      }

      // Check if values are already extrapolated (any value > 1.5 suggests already in 0-100 range)
      const values = Object.values(transparencyChecks);
      if (values.length === 0) {
        return transparencyChecks;
      }

      const maxValue = Math.max(...values);
      if (maxValue > 1.5) {
        // Already extrapolated, return as is
        return transparencyChecks;
      }

      // Need to extrapolate from 0-1.5 to 0-100
      const factor = 100;
      const extrapolated_data = {};

      for (const [key, value] of Object.entries(transparencyChecks)) {
        if (value != 0) {
          extrapolated_data[key] = Math.min(value * factor, 100);
        } else {
          extrapolated_data[key] = 0;
        }
      }

      return extrapolated_data;
    },

    openTransparencyDialog(item) {
      this.selectedTransparencyChecks = this.extrapolateTransparencyChecks(item.transparency_checks);
      this.showTransparencyBreakdown = true;
    },

    openTransparencyDialogFromHeader() {
      // Use first row's data as sample when opening from header
      const firstRowChecks = (this.processedRows.length > 0 && this.processedRows[0].transparency_checks)
        ? this.processedRows[0].transparency_checks
        : null;
      this.selectedTransparencyChecks = this.extrapolateTransparencyChecks(firstRowChecks);
      this.showTransparencyBreakdown = true;
    },

  }
};
</script>

<style scoped>
::v-deep .v-expansion-panel-content__wrap {
  padding-left: 0px;
}

.v-card__text,
.v-card__title {
  word-break: normal;
  /* maybe !important  */
}

.tender {
  border-left: 5px solid #ff4081 !important;
}

.card-data {
  width: 150px !important;
}

.table-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.results-table {
  min-width: 100%;
  display: table !important;
}

/* Force table layout on all screen sizes */
::v-deep .results-table .v-data-table__wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

::v-deep .results-table table {
  width: 100%;
  table-layout: auto;
  min-width: 1200px;
}

/* Responsive toolbar buttons */
@media (max-width: 959px) {
  .toolbar-btn-responsive {
    min-width: 36px !important;
    padding: 0 8px !important;
  }

  .toolbar-btn-responsive .v-icon--left {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

/* Disable all transitions and animations for performance */
::v-deep .results-table * {
  transition: none !important;
  -webkit-transition: none !important;
  animation: none !important;
  -webkit-animation: none !important;
}

/* Disable transitions on menu components for instant selection feedback */
::v-deep .v-menu__content {
  transition: none !important;
  -webkit-transition: none !important;
}

::v-deep .results-table table {
  border-collapse: collapse;
}

::v-deep .results-table th {
  border-bottom: 1px solid #535353;
}

::v-deep .results-table tbody tr:hover {
  background: #535353;
}

/* Reduce spacing between select box and gov avatar columns */
::v-deep .results-table td:nth-child(1),
::v-deep .results-table th:nth-child(1) {
  padding-right: 4px !important;
}

::v-deep .results-table td:nth-child(2),
::v-deep .results-table th:nth-child(2) {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

/* Reduce spacing between gov avatar and notice columns */
::v-deep .results-table td:nth-child(3),
::v-deep .results-table th:nth-child(3) {
  padding-left: 4px !important;
}

/* Title wrapping - allow 2 lines before truncating */
.title-wrap-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  line-height: 1.4;
}

/* Title column visual hierarchy and spacing */
.title-main {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.87);
}

.title-meta {
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.6);
}

.title-category {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.6);
}

.title-tags {
  margin-top: 4px;
}


.v-select--dense .v-input__control {
  height: 20px !important;
}

.state-line {
  width: 100%;
  text-align: right;
  border-bottom: 1px solid #4eb888;
  line-height: 0.1em;
  margin: 10px 0px 20px;
}

.state-line-span {
  padding: 0 10px;
}

.state {
  margin: 20px;
  overflow: hidden;
  color: gray;
  text-align: right;
  line-height: 1.6em;
}

.state:before {
  display: block;
  float: left;
  margin-top: 0.8em;
  /* half the line-height */
  border-top: 2px solid silver;
  width: 95%;
  content: "";
}
</style>
